import React from 'react';
import { Sparkles, Loader2 } from 'lucide-react';

export const ChatLoadingIndicator: React.FC = () => {
  return (
    <div className="flex gap-3">
      <div className="flex-shrink-0 w-8 h-8 bg-gray-900 rounded-full flex items-center justify-center">
        <Sparkles className="w-4 h-4 text-white" />
      </div>
      <div className="flex-1 min-w-0 pt-0.5">
        <p className="text-[11px] font-medium text-gray-400 mb-1">Skylarq</p>
        <div className="flex items-center gap-2 text-gray-500">
          <Loader2 className="w-4 h-4 animate-spin" />
          <span className="text-[14px]">Thinking...</span>
        </div>
      </div>
    </div>
  );
};
